/**
 * Earning nav submenu (UserHeader + AuthHeader).
 * Icons: `public/images/earning_menu_*.svg`
 */
export const EARNING_SUBMENU_ITEMS = [
  {
    id: "launchpad",
    title: "Launchpad",
    desc: "Get early access to new crypto projects",
    to: "/launchpad",
    iconSrcDark: "/images/usd_icon_menu2.svg",
    iconSrcLight: "/images/usd_icon_menu2_light.svg",
    className: "launchpad-item",
  },
  // {
  //   id: "refer_earn",
  //   title: "Refer & Earn",
  //   desc: "Invite friends and earn rewards",
  //   to: "/referral",
  //   iconSrcDark: "/images/p2p_icon_menu3.svg",
  //   iconSrcLight: "/images/p2p_icon_menu3_light.svg",
  // },
  // {
  //   id: "vip",
  //   title: "VIP",
  //   desc: "Unlock exclusive benefits and lower fees",
  //   to: "/vip-services",
  //   iconSrcDark: "/images/otcdesk_icon_menu2.svg",
  //   iconSrcLight: "/images/otcdesk_icon_menu2_light.svg",
  // },
  // {
  //   id: "simple_earn",
  //   title: "Simple Earn",
  //   desc: "Earn passive income on your crypto",
  //   to: "/simple-earn",
  //   iconSrcDark: "/images/buy_icon_menu2.svg",
  //   iconSrcLight: "/images/buy_icon_menu2_light.svg",
  // },
  {
    id: "staking",
    title: "Staking",
    desc: "Earn rewards with flexible staking options",
    to: "/staking",
    iconSrcDark: "/images/cossmargin_icon.svg",
    iconSrcLight: "/images/cossmargin_icon_light.svg",
  },
  {
    id: "soft_staking",
    title: "Soft Staking",
    desc: "Earn rewards with flexible staking options",
    to: "/soft-staking",
    iconSrcDark: "/images/convert_icon_menu2.svg",
    iconSrcLight: "/images/convert_icon_menu2_light.svg",
  },
];
